// Apply the runtime's per-track resolution to live DOM nodes. Separate from
// <Player> so the canvas exporter can call it against a server-rendered DOM
// (an offscreen <div>) without React.

import type { AppliedTransform } from "@app/shared/runtime";

// Cache measured path lengths so we don't re-call getTotalLength() every rAF.
const lengthAttr = "data-path-length";

export function measurePathLengths(root: ParentNode) {
  for (const el of root.querySelectorAll("path")) {
    const p = el as SVGPathElement;
    try {
      const len = p.getTotalLength();
      p.setAttribute(lengthAttr, String(len));
      // Pre-stamp dash array so strokeDasharray/Offset transitions look right
      // from frame 1, even before the first applied keyframe writes them.
      p.style.strokeDasharray = `${len} ${len}`;
      p.style.strokeDashoffset = `${len}`;
    } catch { /* zero-length paths throw — fine */ }
  }
}

export function applyResolution(root: ParentNode, a: AppliedTransform) {
  const els = root.querySelectorAll(a.selector);
  els.forEach((node) => {
    const el = node as SVGGraphicsElement & HTMLElement;
    el.style.transform = a.transform;
    el.style.opacity = a.opacity.toFixed(4);
    for (const [k, v] of Object.entries(a.styles)) {
      (el.style as any)[k] = v;
    }
    if (a.attrs["fill-opacity"]) el.setAttribute("fill-opacity", a.attrs["fill-opacity"]);
    if (a.attrs["stroke-opacity"]) el.setAttribute("stroke-opacity", a.attrs["stroke-opacity"]);
    const da = a.attrs["stroke-dasharray-norm"];
    const dof = a.attrs["stroke-dashoffset-norm"];
    if (da != null && dof != null) {
      const lenStr = el.getAttribute(lengthAttr);
      if (lenStr) {
        const len = parseFloat(lenStr);
        el.style.strokeDasharray = `${len} ${len}`;
        el.style.strokeDashoffset = String(len * parseFloat(dof));
      }
    }
  });
}
